<template>
  <div class="reunfd">
    <nav-bar/>
    <search-bar/>
    <div class="main">
      <div class="header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/me/finance' }">财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>订单详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="order_box">
        <!--  表头-->
        <div class="fr ac fz12">
          <div class="center order-list-item">产品信息</div>
          <div class="center order-list-item">产品规格</div>
          <div class="center order-list-item">设备信息</div>
          <div class="center order-list-item">配套工艺</div>
          <div class="center order-list-item">产品价格</div>
          <div class="center order-list-item">数量</div>
        </div>
        <el-divider/>

        <!-- 列表-->
        <div class="order-list fz12">
          <div class="order-item mt20">
            <!--    上-->
            <div class="top">
              <span>{{ feedback.create_time }}</span>
              <span class="ml20 grey">订单编号：{{ feedback.order_no }}</span>
              <span class="ml40 blue">{{ feedback.order_state_show }}</span>
            </div>
            <!--    中-->
            <!-- 商品信息 -->
            <div class="order">
              <div class="fr jc ac order_left">
                <div class="fr afs pl10 pr20 pt20 pb20 order-list-item">
                  <el-image
                      class="goods_img fs mr10"
                      :src="feedback.orderGoodsBean.goods_img"
                      alt
                  />
                  <p class>{{ feedback.orderGoodsBean.goods_name }}
                    {{ feedback.orderGoodsBean.goods_standard_name }}</p>
                </div>
                <div class="center order-list-item">-</div>
                <div class="center order-list-item">-</div>

                <div class="center cursor order-list-item bule">-</div>
                <div class="center order-list-item">
                  ￥{{ feedback.orderGoodsBean.goods_price }}{{ feedback.orderGoodsBean.price_unit }}
                </div>
                <div class="center order-list-item">
                  {{ feedback.orderGoodsBean.goods_num }}{{ feedback.orderGoodsBean.specification_unit }}
                </div>
                <div class="center order-list-item red"></div>
              </div>
            </div>
            <div class="pt20 pb20 fr ac jfe">
              <p>退款金额：</p>
              <p class="red mr10">￥{{ feedback.handle_platform_price }}</p>
            </div>
          </div>
        </div>
        <div class="reund mt20">
          <p class="black bold mb20">退款信息</p>
          <el-table :data="feedback_list" border style="width: 100%">
            <el-table-column
                fixed
                prop="create_time"
                label="日期"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                prop="pay_way_show"
                label="退款方式"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                prop="pay_state_show"
                label="退款状态"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                prop="order_actual_price"
                label="实收金额"
                align="center"
                header-align="center"
            ></el-table-column>
            <el-table-column
                prop="pay_state_show"
                label="退款凭证"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                <el-image
                    :src="i"
                    v-for="(i,k) in scope.row.pay_charge.split(',')"
                    :key="k"
                    class="img"
                    :preview-src-list="scope.row.pay_charge.split(',')"
                />
              </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="操作"
                width="150"
                align="center"
                header-align="center"
            >
              <template slot-scope="scope">
                <el-button
                    type="text"
                    size="small"
                    @click="confirm(scope.row.order_pay_id)"
                    v-if="scope.row.pay_state !== '1' && hasPermission(906)"
                >确认收款
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";

export default {
  data() {
    return {
      feedback: {},
      feedback_list: []
    };
  },
  created() {
    this.feedback = this.getItem("feedback", 1);
    this.getOrderFeedbackPays();
  },
  methods: {
    confirm(id) {
      this.$prompt("请输入收款金额", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\d+(?=\.{0,1}\d+$|$)/,
        inputErrorMessage: "金额格式不正确"
      })
          .then(({value}) => {
            this.post("orderInterfaces/v1.0/confirmOrderFeedbackPay", {
              order_pay_id: id,
              order_actual_price: value
            }).then(res => {
              this.$message({
                type: "success",
                message: res.data
              });
              this.getOrderFeedbackPays();
            });
          })
          .catch(() => {
          });
    },
    getOrderFeedbackPays() {
      this.post("orderInterfaces/v1.0/getOrderFeedbackPays", {
        feedback_id: this.feedback.feedback_id
      }).then(res => {
        this.feedback_list = res.data;
      });
    }
  },
  components: {NavBar, SearchBar, FooterBar}
};
</script>

<style scoped lang="scss">
.reunfd {
  .main {
    margin: 0 auto;
    width: 1200px;

    .header {
      margin-top: 10px;
      background-color: #fff;
      padding: 20px;
      margin-bottom: 10px;
    }

    .order_box {
      padding: 20px;
      background-color: #fff;

      .order-list-item {
        &:nth-of-type(1) {
          width: 400px;
        }

        &:nth-of-type(2) {
          width: 100px;
        }

        &:nth-of-type(3) {
          width: 140px;
        }

        &:nth-of-type(4) {
          width: 100px;
        }

        &:nth-of-type(5) {
          width: 140px;
        }

        &:nth-of-type(6) {
          width: 140px;
        }

        &:nth-of-type(7) {
          width: 140px;
        }
      }

      .order-list {
        .order-item {
          border: 1px solid #e5e5e5;

          .top {
            background-color: #f0f6ff;
            padding: 14px;
          }

          .order {
            border-bottom: 1px solid #e5e5e5;

            .order_left {
              &:last-child {
                border-bottom: none;
              }

              .goods_img {
                width: 80px;
                height: 80px;
              }
            }

            .operating {
              p {
                margin-top: 10px;

                &:nth-of-type(1) {
                  margin-top: 0;
                }
              }
            }
          }
        }
      }
    }

    .img {
      width: 100px;
      height: 100px;
      margin-right: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/finance/reunddetail.vue